module.exports = __webpack_public_path__ + "static/media/ta.027014db.png";